import ApiService from "./apiService";

export default class Auth {
  isAuthenticated() {
    if (localStorage.getItem("accessToken")) {
      return true;
    } else {
      return false;
    }
  }

  async authenticate(res) {
    localStorage.clear();
    localStorage.setItem(
      "accessToken",
      `${res.data.token_type} ${res.data.access_token}`
    );
    localStorage.setItem("userData", JSON.stringify(res.data.auth));
    localStorage.setItem("menu", JSON.stringify(res.data.access_menu));
    localStorage.setItem("module", JSON.stringify(res.data.access_module));
    const puskesmasProfile = await this.getProfile(res.data.auth.puskesmas_id);
    if (puskesmasProfile) {
      localStorage.setItem(
        "puskesmasProfile",
        JSON.stringify(puskesmasProfile)
      );
      window.location.reload();

      return true;
    }
  }

  async getProfile(puskesmasId) {
    try {
      const result = await ApiService.get(
        `/management/profiles/read?code=${puskesmasId}`
      );
      if (result) return result.data;
    } catch (error) {
      console.error(error);
    }
  }

  logout() {
    this.isAuthenticated = false;
    localStorage.clear();
    window.location.reload();
  }
}
